import type { TunerError } from '../state/tuner-store'

interface ErrorNoticeProps {
  readonly error: TunerError
}

/** Extra guidance beyond the error message itself. */
function hintFor(error: TunerError): string | null {
  switch (error.kind) {
    case 'insecure-context':
      return 'Mikrofonzugriff geben Browser nur über https:// oder http://localhost frei.'
    case 'permission-denied':
      return 'In Chrome: das Kamerasymbol in der Adressleiste. In Safari: Einstellungen → Websites → Mikrofon.'
    case 'no-device':
      return 'Prüfen, ob das Audiointerface eingeschaltet und angeschlossen ist.'
    case 'device-busy':
      return 'Möglicherweise belegt eine DAW oder ein Konferenzprogramm den Eingang exklusiv.'
    default:
      return null
  }
}

/** Blocking error banner with an actionable hint. */
export function ErrorNotice({ error }: ErrorNoticeProps): React.JSX.Element {
  const hint = hintFor(error)

  return (
    <div className="notice notice--error" role="alert">
      <p className="notice__message">{error.message}</p>
      {hint !== null && <p className="notice__hint">{hint}</p>}
    </div>
  )
}
